export const actionType = {
    SEARCHTRIPS_REQUEST: 'SEARCHTRIPS_REQUEST',
    SEARCHTRIPS_SUCCESS: 'SEARCHTRIPS_SUCCESS',
    SEARCHTRIPS_FAILURE: 'SEARCHTRIPS_FAILURE', 
};